module.exports = __webpack_public_path__ + "static/media/4bwhite.10688acf.png";